export const tooltipContents = {
  severityCode:
    'Severity Code - if 1, 2 or 3 record did not update.  If 4 or 5 record updated but requires review',
  customerName: 'Identifies the Customer being viewed',
  policyNbr: 'Policy Number',
  subscrId: 'Subscriber ID for Prime customer',
  name: 'Name of member',
  relationship: 'Relationship code',
  type: 'Type of current transaction',
  stsCode: 'Status of the current transaction',
  warningName:
    'Identifies the cause of the warning. The update was made to the destination system',
  errorName: 'Identifies the cause of the error or warning',
  fieldName:
    'Identifies the submission field where the warning may have occurred',
  custData:
    'Identifies the value or the incorrect data field which was submitted',
  sourceData:
    'Identifies the Source Data (Eligibility System Data) populated for that particular field',
  detailView:
    'Displays a table representing the data used to process the eligibility transaction',
  dob: 'Date of birth of member',
  covType: 'Type of Coverage, i.e. Medical, Dental, etc.',
  covStrtDt: 'Start date of coverage for the coverage type',
  covEndDt: 'Termination date of coverage for the coverage type',
  dataPriorToProcessing:
    'Identifies the corresponding value in the destination system that was previously recorded for that particular field',
  dataAfterProcessing:
    'Identifies the value that has been processed in the Electronic Eligibility System',
  //other headers
  ERWSum: 'Displays a count of all errors and warnings',
  SubCorrReq:
    'Displays all records which require submitter review due to errors which occurred in processing',
  EEAReq:
    'Displays all records which require EEA review due to errors which occurred in processing',
  CustomerCorrReq: 'Displays all external errors and warnings',
  EEACorrReq: 'Displays all internal errors and warnings',
  count: 'Number of records impacted',
  //Relationship codes
  EE: 'Employee',
  CD: 'Collateral Dependent',
  CH: 'Child',
  DP: 'Domestic Partner',
  HC: 'Disabled (Handicapped) Child',
  NB: 'Newborn',
  OT: 'Other',
  RR: 'Retiree',
  SC: 'Stepchild',
  SD: 'Sponsored Dependent',
  SP: 'Spouse',
  SS: 'Surviving Spouse',
  ST: 'Student',
  //Coverage Type codes
  H: 'Medical',
  D: 'Dental',
  V: 'Vision',
  L: 'Life',
};
export const SECTIONS = {
  CUSTOMER_DETAILS: 'customerDetails',
  THRESHOLD: 'Threshold',
};
export const MODELS = {
  //CUSTOMER DETAILS
  ASSIGN_SUBMISSION_ID: 'customerDetails.submitterAssignId',
  CUSTOMER_NUMBER: 'customerDetails.customerNumber',
  DESTINATION_SYSTEM: 'customerDetails.destinationSystem',
  COMPLEXITY_RATING: 'customerDetails.complexityRating',
  VERSION_EFFECTIVE_DATE: 'customerDetails.versionEffectiveDate',
  PROFILE_TYPE: 'customerDetails.profileType',
  SECURITY_ACCESS: 'customerDetails.securityAccess',
  SUBMISSION_GROUP_NAME: 'customerDetails.submitterGroupName',
  POLOCY_NUMBER: 'customerDetails.policyNumber',
  LEGAL_ENTITY: 'customerDetails.legalEntity',
  PROFILE_STATUS: 'customerDetails.profileStatus',
  MARKET_SEGMENT: 'customerDetails.marketSegment',
  VERSION_END_DATE: 'customerDetails.versionEndDate',

  // FILE DETAILS
  FILE_FREQUENCY: 'fileDetails.frequencyCode',
  CHANNEL_TYPE: 'fileDetails.transmitCode',
  FILE_FORMAT_CODE: 'fileDetails.fileFormatTypeCode',
  ELIGYBILTY_CODE: 'fileDetails.eligibilitySourceType',
  FILE_INDICATOR: 'fileDetails.fileIndicator',
  NEXT_FILE_EXPECTED_DATE: 'fileDetails.nextFileExpectedDate',
  VDB_MAPPING_INDICATOR: 'fileDetails.vbdMappingIndicator',
  FEED_TO_VENDOR: 'fileDetails.',

  //DEMOGRAPHICS

  OE_EFFECTIVE_DATE: 'demographics.openEnrollmentDate',
  DOMESTIC_STREET_ADDRESS_1: 'demographics.domesticStreetAddress1',
  DOMESTIC_CITY: 'demographics.domesticCity',
  EARLIEST_START_DATE: 'demographics.earliestStartDate',
  DOMESTIC_STREET_ADDRESS_2: 'demographics.domesticStreetAddress2',
  DOMESTIC_STATE_CODE: 'demographics.domesticStateCode',
  PRE_EXISTING_INDICATOR: 'demographics.preExistingInfoIndicator',
  ENROLL_REASON_REQUIRED: 'demographics.enrollmentReasonCodeRequired',
  DOMESTIC_POSTAL_CODE: 'demographics.domesticPostalCode',
  DOMESTIC_EXTENSION:'demographics.domesticPostalExtensionCode',
  EMAIL_NOTOFICATION:'demographics.emailNotificationCode',

  
  

  //THRESHOLD

  SUBMISSION_POPULATION: 'thresholdProcessing.submitterGroupPopulation',
  AUTO_CANCEL_INDICATOR: 'thresholdProcessing.autoCancelIndicator',
};

export const LABELS = {
  //CUSTOMER DETAILS
  ASSIGN_SUBMISSION_ID: 'Customer submitter Id',
  CUSTOMER_NUMBER: 'Customer Number',
  DESTINATION_SYSTEM: 'Destination System',
  COMPLEXITY_RATING: 'Complexity Rating',
  PROFILE_TYPE: 'Profile Type',
  VERSION_EFFECTIVE_DATE: 'Version Effective Date',
  SECURITY_ACCESS: 'Security Access',
  SUBMISSION_GROUP_NAME: 'Customer Submission Name',
  POLOCY_NUMBER: 'Policy Number',
  LEGAL_ENTITY: 'Legal Entity',
  PROFILE_STATUS: 'Profile Status',
  MARKET_SEGMENT: 'Market Segment',
  VERSION_END_DATE: 'Version End Date',
  CUSTOMER_SUBMISSION_NAME: 'Customer Submission Name',
  GPS_EMP_GROUP_ID: 'GPS Employer Group Id',

  //FILE DETAILS
  FILE_FREQUENCY: 'File Frequency',
  CHANNEL_TYPE: 'Channel Type',
  FILE_FORMAT_CODE: 'File Format',
  FILE_INDICATOR: 'File Indicator',
  NEXT_FILE_EXPECTED_DATE: 'Next File Expected Date',
  ELIGYBILTY_CODE: 'Eligibility Source Type',
  VDB_MAPPING_INDICATOR: 'VBD Mapping',

  //DEMO GRAPICS

  OE_EFFECTIVE_DATE: 'OE Effective Date',
  DOMESTIC_STREET_ADDRESS_1: 'Domestic Street Address 1',
  DOMESTIC_CITY: 'Domestic City',
  EARLIEST_START_DATE: 'Earliest Start Date',
  DOMESTIC_STREET_ADDRESS_2: 'Domestic Street Address 2',
  DOMESTIC_STATE_CODE: 'Domestic State',
  PRE_EXISTING_INDICATOR: 'Pre-existing Info Required',
  ENROLL_REASON_REQUIRED: 'Enrollment Reason Code Required',
  DOMESTIC_POSTAL_CODE: 'Domestic Zip Code',
  EMAIL_NOTIFICATION:'Email Notification',

  //THRESHOLD
  SUBMISSION_POPULATION: 'Profile Population',
  AUTO_CANCEL_INDICATOR: 'Auto-Cancel Indicator',
};
export const thresholdOptions = [
  { label: '', value: '' },
  { label: '0', value: 0 },
  { label: '0.1', value: 0.1 },
  { label: '0.5', value: 0.5 },
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5', value: 5 },
  { label: '10', value: 10 },
  { label: '15', value: 15 },
  { label: '20', value: 20 },
  { label: '25', value: 25 },
  { label: '30', value: 30 },
  { label: '35', value: 35 },
  { label: '40', value: 40 },
  { label: '45', value: 45 },
  { label: '50', value: 50 },
  { label: '55', value: 55 },
  { label: '60', value: 60 },
  { label: '65', value: 65 },
  { label: '70', value: 70 },
  { label: '75', value: 75 },
  { label: '80', value: 80 },
  { label: '85', value: 85 },
  { label: '90', value: 90 },
  { label: '95', value: 95 },
  { label: '100', value: 100 },
];
export const dSystems = {
  CDB: '',
  GPS: 'GPS',
  PRIME: 'PRIME',
};
export const DestinationCheck ={
  GPS:"G",
  CDB:"8",
  PRIME:'5'
}
export const OptionsforFileDeatils = [
  {
    label: 'Yes',
    value: "1",
  },
  {
    label: 'No',
    value: "2",
  },
];
export const ruless = [ 
  {
      "id": 20,
      "name": "AutoCancelLastDayofPriorMonth",
      "category": "Auto-Cancel",
      "description": "Auto Cancel Date will be moved to the last date of the current month based on the file receipt date."
  },
  {
      "id": 770,
      "name": "BuildPrescriptionDrugCoverageLineFromMedicalCoverage",
      "category": "Build Prescription Drug Coverage",
      "description": "Prescription Drug coverage is submitted on the file."
  },
  {
      "id": 640,
      "name": "DoNotUpdateCOBRAMembers",
      "category": "COBRA Processing",
      "description": "COBRA members on source are updated by the file."
  },
  {
      "id": 30,
      "name": "WaitingPeriod0Day",
      "category": "Coverage Start Date",
      "description": "Coverage Start Date on file is used if provided, otherwise the employment start date is used."
  },
  {
      "id": 280,
      "name": "Deductible.5PercentOfSalary",
      "category": "Deductibles - In Network",
      "description": "Accept the Values on the File"
  },
  {
      "id": 340,
      "name": "AcceptFileValuesforDeductiblesOutofNetwork",
      "category": "Deductibles - Out of Network",
      "description": "Accept the Values on the File"
  },
  {
      "id": 750,
      "name": "PropagateUnmatchedDepOnlyCovToSubscriber",
      "category": "Dependent Only Processing",
      "description": "Members covered code will be derived for dependents with dependent only coverage when a coverage exists on the dependent but not the subscriber.  The unmatched dependent only coverage will be propagated to the subscriber."
  },
  {
      "id": 880,
      "name": "DeriveEmploymentStartDateIfNotOnFile",
      "category": "Employment Start Date",
      "description": "When Employment Start Date is not on the file, the Employment Start Date is derived to be the earliest coverage start date of all coverage types."
  },
  {
      "id": 210,
      "name": "IDCardPrint3DayWait",
      "category": "ID Card Print Date",
      "description": "ID Cards are printed 3 days after the file is processed"
  },
  {
      "id": 570,
      "name": "ManagedCareIDCardSwitchOff",
      "category": "Managed Care ID Card Switches",
      "description": "Managed Care ID Card Switch is set off"
  },
  {
      "id": 810,
      "name": "AcceptFileValuesForMedicare",
      "category": "Medicare Processing",
      "description": "Medicare Data is populated from the file."
  },
  {
      "id": 940,
      "name": "MemberSSNIsAccepted",
      "category": "Member Social Security Number Validation",
      "description": "Do not display pends if member SSN is missing, or does not meet Social Security format guidelines."
  },
  {
      "id": 910,
      "name": "MultipleMemberTransactionsAreNotAllowed",
      "category": "Multiple Member Transaction Processing",
      "description": "Multiple coverage lines for the same coverage type are not accepted. Only a single coverage line per coverage type is submitted on the file."
  },
  {
      "id": 720,
      "name": "OptInsNotAllowed",
      "category": "Opt-In Processing",
      "description": "Members are not allowed to opt-into a market site."
  },
  {
      "id": 310,
      "name": "AcceptFileValuesforOOP",
      "category": "Out Of Pocket - In Network",
      "description": "Accept the Values on the File"
  },
  {
      "id": 380,
      "name": "AcceptFileValuesforOOPOutofNetwork",
      "category": "Out Of Pocket - Out of Network",
      "description": "Accept the Values on the File"
  },
  {
      "id": 220,
      "name": "FileAddressIsAlwaysCorrect",
      "category": "Overlay Logic",
      "description": "Address information on the file is updated to the system regardless of the last change."
  },
  {
      "id": 890,
      "name": "PartialTransactionsAreNotAllowed",
      "category": "Partial Transaction Processing",
      "description": "Partial Transactions are not accepted.  All required fields must be submitted on the file."
  },
  {
      "id": 260,
      "name": "PCPDefaultsAssigned",
      "category": "PCP Information",
      "description": "A default PCP is assigned to members if there is not one on the file for each coverage."
  },
  {
      "id": 510,
      "name": "UpdatePCPInformation",
      "category": "PCP Update Choices",
      "description": "PCP information will be updated with all the files."
  },
  {
      "id": 850,
      "name": "AllowUpdatetoRetirementDateandRRTicRel",
      "category": "Retirement Processing",
      "description": "Updates to Retirement Dates and/or Retiree Tic Rel are accepted."
  },
  {
      "id": 490,
      "name": "DoNotUpdateSalaryOOPandDeductibleInformation",
      "category": "Salary/Out Of Pocket/Deductible Update Choices",
      "description": "Salary, Deductible and OOP information will not be updated."
  },
  {
      "id": 605,
      "name": "AcceptandRequireStartDatesonFileStartDateChangesAllowed",
      "category": "Start Date Processing",
      "description": "Start Dates must be provided on the file and changes before the earliest source start dt are applied."
  },
  {
      "id": 440,
      "name": "SurvivingMembersCoveredUnderDeceasedID",
      "category": "Surviving Members Covered",
      "description": "The death date will be applied to the subscriber. All members with open coverage will not be termed."
  },
  {
      "id": 470,
      "name": "TermOnDateOfRequest",
      "category": "Termination",
      "description": "Term Dates will remain as noted on the file (or through derivation)"
  },
  {
      "id": 830,
      "name": "DoNotTerminateUnmatchedCoverage",
      "category": "Unmatched Coverage",
      "description": "Unmatched Coverage will not be terminated."
  }
];
export const gpsRules= [
  {
      "id": 7610,
      "name": "DoNotAcceptFamilyId",
      "category": "FamilyID",
      "description": "Do not allow Family ID field to be passed downstream when it is provided and this rule is selected."
  },
  {
      "id": 4542,
      "name": "SetSignatureDateToFileReceivedDateWhenBlank",
      "category": "Signature Date",
      "description": "When signature date on file is blank or invalid set signature date to file received date. (Standard/Default logic)"
  }
]
export const primeRules = [
  {
      "id": 870,
      "name": "DeriveEmploymentStartDateIfNotOnFile",
      "category": "Employment Start Date",
      "description": "Employment Start Date is Required and Accepted on file."
  },
  {
      "id": 810,
      "name": "DeriveMedicareDataForRetireesIfNotOnFile",
      "category": "Medicare Processing",
      "description": "Medicare Data is populated from the file."
  },
  {
      "id": 530,
      "name": "UpdatePCPInformation",
      "category": "PCP Update Choices",
      "description": "PCP information will be updated if there is nothing on the source system."
  },
  {
      "id": 860,
      "name": "AllowUpdatetoRetirementDateandRRTicRel",
      "category": "Retirement Processing",
      "description": "Updates to Retirement Dates and/or RR Tic Rel are not accepted."
  },
  {
      "id": 605,
      "name": "AcceptandRequireStartDatesonFileStartDateChangesNotAllowed",
      "category": "Start Date Processing",
      "description": "Start Dates must be provided on the file and changes before the earliest source start dt are applied."
  },
  {
      "id": 470,
      "name": "TermEndOfMonth",
      "category": "Termination",
      "description": "Term Dates will remain as noted on the file (or through derivation)"
  }
];

export const marketSegmentsPg = [
  {
      "value": "1",
      "label": "SSG"
  },
  {
      "value": "2",
      "label": "KEY ACCOUNTS"
  },
  {
      "value": "3",
      "label": "N/A"
  },
  
  {
      "value": "5",
      "label": "OPTUM"
  },
  {
      "value": "6",
      "label": "Medicare"
  },
  {
      "value": "7",
      "label": "Medicaid"
  }
]

export const encdata ="encrfdecrpdlata@#$%*((*&^%$#$%^&*&^%$#!@#$%^&*()(*&^%"